import { useTranslation } from 'react-i18next';

import type { AdminStatus } from '../types/admin.types';

// Color is an FE concern (status code → badge variant). Label + tooltip text come from the
// backend-served label catalog ('labels' namespace), keyed by the wire status code.
const VARIANT_CLASS: Record<AdminStatus, string> = {
  ACTIVE: 'badge-success',
  INACTIVE: 'badge-secondary',
  PENDING: 'badge-gray',
  WITHDRAWN: 'badge-destructive',
};

interface AdminStatusBadgeProps {
  status: AdminStatus;
}

export function AdminStatusBadge({ status }: AdminStatusBadgeProps) {
  const { t } = useTranslation('labels');
  return (
    <span
      className={`badge ${VARIANT_CLASS[status]} admin-status-badge`}
      data-tip={t(`adminStatusTooltip.${status}`)}
    >
      {t(`adminStatus.${status}`)}
    </span>
  );
}
